import { Link } from 'react-router';
import { Receipt, ShoppingCart, UserRound } from 'lucide-react';
import type { ReactNode } from 'react';
import { useSession } from '../../app/session';
import { PageHeader } from '../../ui';

/** Landing page for staff without the overview dashboard (e.g. cashiers). */
export function HomePage() {
  const { me, can } = useSession();
  const first = me.user.fullName.split(' ')[0];
  return (
    <>
      <PageHeader title={`Welcome, ${first}`} description={`You're signed in as ${me.user.roleName} at ${me.business.tradingName ?? me.business.name}.`} />
      <div className="grid gap-4 sm:grid-cols-3">
        {can('pos.sell') && <Tile to="/pos" icon={<ShoppingCart className="size-6" />} title="Open the till" text="Scan items and take payment." primary />}
        {can('pos.sell') && <Tile to="/sales" icon={<Receipt className="size-6" />} title="My sales" text="Find a receipt and reprint it." />}
        <Tile to="/account" icon={<UserRound className="size-6" />} title="My account" text="Change your password." />
      </div>
    </>
  );
}

function Tile({ to, icon, title, text, primary }: { to: string; icon: ReactNode; title: string; text: string; primary?: boolean }) {
  return (
    <Link
      to={to}
      className={`flex flex-col gap-3 rounded-[var(--radius-panel)] border p-5 transition-colors ${
        primary ? 'border-ledger-700 bg-ledger-700 text-white hover:bg-ledger-800' : 'border-line bg-surface hover:border-ledger-500/50'
      }`}
    >
      {icon}
      <span>
        <span className="block text-lg font-semibold">{title}</span>
        <span className={primary ? 'text-white/75' : 'text-muted'}>{text}</span>
      </span>
    </Link>
  );
}
